// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipsResultsListItem from './pips-results-list-item';

const PipsResultsList = props => (
    <ul className='open-pips-results-list'>
        <ListViewShowMore
            initialShowItems={50}
            perMoreMultiplier={1.25}
            showAllOption={true}
            showPerMore={50}
            totalItems={props.pipProducts.length}
        >
            {props.pipProducts.map((pipProduct, index) =>
                <PipsResultsListItem
                    key={index}
                    pipProduct={pipProduct}
                />
            )}
        </ListViewShowMore>
    </ul>
);

PipsResultsList.displayName = 'PipsResultsList';
PipsResultsList.propTypes = {
    pipProducts: PropTypes.arrayOf(PropTypes.instanceOf(PipProduct)).isRequired
};

export default PipsResultsList;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pips-results-list.js